export default {"src":"https://cdn.jetlend.ru/_next/static/media/empty_brokers__icon.875ca19d.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};